// Common utilities
export * from './common/types';
export * from './common/utils';
export * from './common/queue';
// Env utilities moved to @skin-seoul/env-utils package
// export * from './common/env';

// Product domain
export * from './product/productAPIClient';
export * from './product/utils/types';
export * from './product/utils/keys';
export * from './product/utils/queries';
export * from './product/utils/recommendationError';

// Review domain
export * from './review/reviewAPIClient';
export * from './review/utils/types';
export * from './review/utils/keys';
export * from './review/utils/queries';

// What People Say domain (SSD-5362)
export * from './whatPeopleSay/whatPeopleSayAPIClient';
export * from './whatPeopleSay/utils/types';
export * from './whatPeopleSay/utils/keys';
export * from './whatPeopleSay/utils/queries';

// Competitor domain
export * from './competitor/competitorAPIClient';
export * from './competitor/utils/types';
export * from './competitor/utils/keys';
export * from './competitor/utils/queries';

// Cart domain
export * from './cart/cartAPIClient';
export * from './cart/utils/types';
export * from './cart/utils/keys';
export * from './cart/utils/queries';
export * from './cart/utils/cartTokenQueue';

// Loyalty domain
export * from './loyalty/loyaltyAPIClient';
export * from './loyalty/utils/types';
export * from './loyalty/utils/keys';
export * from './loyalty/utils/queries';

// User domain
export * from './user/userAPIClient';
export * from './user/utils/types';
export * from './user/utils/keys';
export * from './user/utils/queries';

// Auth (OTP Login/Register) domain
export * from './auth/authAPIClient';
export * from './auth/utils/types';
export * from './auth/utils/keys';
export * from './auth/utils/queries';

// Gorgias session identity domain
export * from './gorgiasSessionIdentity';

// Wishlist domain
export * from './wishlist/wishlistAPIClient';
export * from './wishlist/utils/types';
export * from './wishlist/utils/keys';
export * from './wishlist/utils/queries';

// Banner domain
export * from './banner/bannerAPIClient';
export * from './banner/utils/types';
export * from './banner/utils/keys';
export * from './banner/utils/queries';

// TrendingVideo domain
export * from './trendingVideo/trendingVideoAPIClient';
export * from './trendingVideo/utils/types';
export * from './trendingVideo/utils/keys';
export * from './trendingVideo/utils/queries';

// Blog domain
export * from './blog/blogAPIClient';
export * from './blog/utils/types';
export * from './blog/utils/keys';
export * from './blog/utils/queries';

// Device domain
export * from './device/deviceAPIClient';
export * from './device/utils/types';
export * from './device/utils/keys';
export * from './device/utils/queries';

// Fibo domain
export * from './fibo/fiboAPIClient';
export * from './fibo/utils/types';
export * from './fibo/utils/keys';
export * from './fibo/utils/queries';

// Page domain
export * from './page/pageClient';
export * from './page/utils/types';
export * from './page/utils/keys';
export * from './page/utils/queries';

// Payment domain
export * from './payment/paymentAPIClient';
export * from './payment/utils/types';
export * from './payment/utils/keys';
export * from './payment/utils/queries';

// Siteconfig domain
export * from './siteconfig/siteconfigAPIClient';
export * from './siteconfig/utils/types';
export * from './siteconfig/utils/keys';
export * from './siteconfig/utils/queries';

// WooCommerce domain
export * from './woocommerce/woocommerceAPIClient';
export * from './woocommerce/utils/types';
export * from './woocommerce/utils/keys';
export * from './woocommerce/utils/queries';

// Order domain
export * from './order/orderAPIClient';
export * from './order/utils/types';
export * from './order/utils/keys';
export * from './order/utils/queries';

// Address domain
export * from './address/addressAPIClient';
export * from './address/utils/types';
export * from './address/utils/keys';
export * from './address/utils/queries';

// Skin Analysis (P1) domain
export * from './skinAnalysis/SkinAnalysisAPIClient';
export * from './skinAnalysis/utils/types';
export * from './skinAnalysis/utils/keys';
export * from './skinAnalysis/utils/queries';
export * from './skinAnalysis/utils/pollFailure';

// Contact domain
export * from './contact/contactAPIClient';
export * from './contact/utils/types';
export * from './contact/utils/keys';
export * from './contact/utils/queries';

// reCAPTCHA domain
export * from './recaptcha';

// Personalization domain
export * from './personalization';

// Analytics domain
export * from './analytics';

// Domain exports will be added as domains are implemented
